import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { ThemeProvider, useTheme } from "next-themes";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import DashboardLayout from "@/components/layout/DashboardLayout";
import Dashboard from "@/pages/Dashboard";
import ResourcePage from "@/pages/ResourcePage";
import TransactionsPage from "@/pages/TransactionsPage";
import LedgerPage from "@/pages/LedgerPage";
import IntegrationsPage from "@/pages/IntegrationsPage";
import ProcessorEnginePage from "@/pages/ProcessorEnginePage";
import DeveloperPortal from "@/pages/DeveloperPortal";
import CorporateApp from "@corporate/CorporateApp";
import VoultApp from "@voult/VoultApp";

function ThemedToaster() {
  const { resolvedTheme } = useTheme();
  return <Toaster position="top-right" theme={resolvedTheme === "light" ? "light" : "dark"} richColors />;
}

function Shell() {
  const { user } = useAuth();

  if (user === undefined) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-indigo-400" />
      </div>
    );
  }
  if (!user) return <Login />;

  return (
    <DashboardLayout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/users" element={<ResourcePage resourceKey="users" />} />
        <Route path="/companies" element={<ResourcePage resourceKey="companies" />} />
        <Route path="/customers" element={<ResourcePage resourceKey="customers" />} />
        <Route path="/accounts" element={<ResourcePage resourceKey="accounts" />} />
        <Route path="/wallets" element={<ResourcePage resourceKey="wallets" />} />
        <Route path="/transactions" element={<TransactionsPage />} />
        <Route path="/ledger" element={<LedgerPage />} />
        <Route path="/ledger-accounts" element={<ResourcePage resourceKey="ledger-accounts" />} />
        <Route path="/services" element={<ResourcePage resourceKey="services" />} />
        <Route path="/currencies" element={<ResourcePage resourceKey="currencies" />} />
        <Route path="/crypto-wallets" element={<ResourcePage resourceKey="crypto-wallets" />} />
        <Route path="/crypto-transactions" element={<ResourcePage resourceKey="crypto-transactions" />} />
        <Route path="/keys" element={<ResourcePage resourceKey="api-keys" />} />
        <Route path="/processors" element={<ResourcePage resourceKey="processors" />} />
        <Route path="/processor-engine" element={<ProcessorEnginePage />} />
        <Route path="/integrations" element={<IntegrationsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </DashboardLayout>
  );
}

function App() {
  return (
    <div className="App">
      <ThemeProvider attribute="class" enableSystem defaultTheme="system">
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/developer" element={<DeveloperPortal />} />
              <Route path="/corporate/*" element={<CorporateApp />} />
              <Route path="/voult/*" element={<VoultApp />} />
              <Route path="/*" element={<Shell />} />
            </Routes>
          </BrowserRouter>
          <ThemedToaster />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
